import React from 'react';
import styles from './ButtonGroup.module.sass';

const ButtonGroup = ({
    children,
    gap, wrap
}: Props) =>
    <div className={`
        ${styles['buttongroup']}
        ${styles['buttongroup__gap--'+(gap || 'medium')]}
        ${styles['buttongroup__wrap--'+(wrap || 'wrap')]}
    `}>
        { children }
    </div>;

interface Props {
    children?: any
    gap?: 'none' | 'medium'
    wrap?: 'wrap' | 'nowrap'
}

export default ButtonGroup;